define([
    ], function () {
        "use strict";

        var FAQHomeView = App.View.extend({
            el: "body",

            events: {
                "click .js-faq": "openFAQ",
            },

            initialize: function () {},

            openFAQByBtn: function ($faqLink) {
                if (!$faqLink.parent().hasClass("is-open")) {
                    this.$el.find(".js-section-faqs .is-open")
                        .removeClass("is-open")
                        .find("i")
                        .removeClass("icon-less-circle")
                        .addClass("icon-plus-circle");
                }

                $faqLink.find("i").toggleClass("icon-plus-circle icon-less-circle");
                $faqLink.parent().toggleClass("is-open");

                if ($faqLink.parent().hasClass("js-faq-config-video") &&
                    $faqLink.parent().hasClass("is-open")) {
                    this.playVideo($faqLink.parent());
                } else if (
                    !$faqLink.parent().hasClass("js-faq-config-video") ||
                    !$faqLink.parent().hasClass("is-open")) {
                }
            },

            openFAQ: function (e) {
                e.preventDefault();
                this.openFAQByBtn($(e.currentTarget));
            }
        });

        return FAQHomeView;
    });
